module.exports = "./images/logo-pariticosmetic.png";